/**
 * Effective enablement for Phased Project Structures (beta, off by default).
 *
 * Mirrors the `modelWalkthrough` beta pattern: a global AppSettings default
 * gates whether the builder exposes the per-proposal "Phased project" switch.
 * A proposal that already has phasing turned on remains manageable everywhere
 * even if the global beta flag is later switched off.
 */
export function isPhasedProjectsFeatureEnabled(opts: {
  /** `AppSettings.phasedProjectsDefaultEnabled` */
  globalDefault?: boolean;
  /** `ProposalBuilderData.phasingEnabled` for the proposal being viewed. */
  proposalPhasingEnabled?: boolean;
}): boolean {
  if (opts.proposalPhasingEnabled === true) return true;
  return opts.globalDefault ?? false;
}
